import Http from '@/api/http_v2.js'

export default {
  index(params) {
    return Http.get(`/products`, { params })
  },
}
